<template>
  <div class="dashboard">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
